<script>
export { render as render };
export { staticRenderFns as staticRenderFns };
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-card",
    [
      _c(
        "div",
        { staticClass: "order-created" },
        [
          _c(
            "div",
            { staticClass: "pl-2--row" },
            [
              _c("b-row", [
                _c("div", { staticClass: "download-order-report" }, [
                  _c("div", [_c("h3", [_vm._v(_vm._s(_vm.$t("ad.My-Ads")))])]),
                  _c("div", [
                    _c(
                      "div",
                      { staticClass: "refresh-btn" },
                      [
                        _c(
                          "b-button",
                          {
                            staticClass: "btn-icon min-80-btn",
                            attrs: { variant: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.createAd()
                              },
                            },
                          },
                          [_vm._v(" " + _vm._s(_vm.$t("ad.Create-Ad")) + " ")]
                        ),
                      ],
                      1
                    ),
                  ]),
                ]),
              ]),
              _c(
                "b-row",
                { staticClass: "mt-1" },
                [_c("AdsFilter", { attrs: { callApi: _vm.callApi } })],
                1
              ),
            ],
            1
          ),
          _c("b-table", {
            staticClass: "mt-2",
            attrs: { items: _vm.items, fields: _vm.fields, responsive: "" },
            scopedSlots: _vm._u([
              {
                key: "cell(id)",
                fn: function (data) {
                  return [
                    _c(
                      "b-link",
                      {
                        staticClass: "text-primary pointer under-line",
                        on: {
                          click: function ($event) {
                            return _vm.showAddDetails(data.item)
                          },
                        },
                      },
                      [_vm._v(_vm._s(data.value))]
                    ),
                  ]
                },
              },
              {
                key: "cell(orderType)",
                fn: function (data) {
                  return [
                    _c(
                      "div",
                      { class: data.value == "SELL" ? "sell" : "buy" },
                      [_vm._v(" " + _vm._s(data.value) + " ")]
                    ),
                  ]
                },
              },
              {
                key: "cell(unitPrice)",
                fn: function (data) {
                  return [_vm._v(_vm._s(data.value + " " + data.item.fiat))]
                },
              },
              {
                key: "cell(createdTime)",
                fn: function (data) {
                  return [_vm._v(" " + _vm._s(_vm.convertDate(data.value)))]
                },
              },
              {
                key: "cell(status)",
                fn: function (data) {
                  return [
                    _c("b-link", { attrs: { href: "#" } }, [
                      _vm._v(_vm._s(data.value)),
                    ]),
                  ]
                },
              },
              {
                key: "cell(actions)",
                fn: function (data) {
                  return [
                    _c(
                      "b-button",
                      {
                        directives: [
                          {
                            name: "b-tooltip",
                            rawName: "v-b-tooltip.hover.v-primary",
                            modifiers: { hover: true, "v-primary": true },
                          },
                        ],
                        staticClass: "btn-icon",
                        class:
                          data.item && data.item.adStatus === "CLOSED"
                            ? "gray-btn"
                            : "",
                        attrs: {
                          variant: "flat-primary",
                          disabled:
                            data.item && data.item.adStatus === "CLOSED",
                          title: _vm.$t("payment.Edit"),
                        },
                        on: {
                          click: function ($event) {
                            return _vm.openUpdateStatus(true, data.item)
                          },
                        },
                      },
                      [_c("feather-icon", { attrs: { icon: "EditIcon" } })],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                {
                  staticClass:
                    "d-flex align-items-center justify-content-center justify-content-sm-end",
                  attrs: { cols: "12", sm: "12" },
                },
                [
                  _vm.isPaginationVisible
                    ? _c("b-pagination", {
                        key: _vm.page,
                        staticClass: "mb-0 mt-1 mt-sm-0",
                        attrs: {
                          "total-rows": _vm.totalRows,
                          "per-page": _vm.size,
                          "first-number": "",
                          "last-number": "",
                          "prev-class": "prev-item",
                          "next-class": "next-item",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "prev-text",
                              fn: function () {
                                return [
                                  _c("feather-icon", {
                                    attrs: {
                                      icon: "ChevronLeftIcon",
                                      size: "18",
                                    },
                                  }),
                                ]
                              },
                              proxy: true,
                            },
                            {
                              key: "next-text",
                              fn: function () {
                                return [
                                  _c("feather-icon", {
                                    attrs: {
                                      icon: "ChevronRightIcon",
                                      size: "18",
                                    },
                                  }),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          false,
                          1308952388
                        ),
                        model: {
                          value: _vm.page,
                          callback: function ($$v) {
                            _vm.page = $$v
                          },
                          expression: "page",
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("KycNotComplete", {
        attrs: {
          msg: _vm.$t("Kyc.kycNotCompleteAd"),
          showPop: _vm.showPop,
          onModalHidden: _vm.onModalHidden,
        },
      }),
      _c(
        "b-modal",
        {
          attrs: {
            "hide-footer": "",
            id: "add-payment",
            centered: "",
            size: "sm",
            "no-close-on-backdrop": true,
          },
          on: {
            hide: function ($event) {
              return _vm.openUpdateStatus(false)
            },
          },
          model: {
            value: _vm.updateStatus,
            callback: function ($$v) {
              _vm.updateStatus = $$v
            },
            expression: "updateStatus",
          },
        },
        [
          _c("h4", { staticClass: "mb-1 text-center head-top-25" }, [
            _vm._v(" " + _vm._s(_vm.$t("ads.Edit-Status")) + " "),
          ]),
          _c(
            "div",
            { staticClass: "status-ads-text" },
            [
              _c(
                "b-form-group",
                { attrs: { label: _vm.$t("ads.Status") } },
                [
                  _c("v-select", {
                    attrs: {
                      options: _vm.adStatuses,
                      clearable: false,
                    },
                    model: {
                      value: _vm.adsStatus,
                      callback: function ($$v) {
                        _vm.adsStatus = $$v
                      },
                      expression: "adsStatus",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm.adsStatus === "CLOSED"
            ? _c("div", { staticClass: "close-ads-text mt-1" }, [
                _vm._v(" " + _vm._s(_vm.$t("ads.ad-Status")) + " "),
              ])
            : _vm._e(),
          _c(
            "div",
            { staticClass: "text-center" },
            [
              _c(
                "b-button",
                {
                  staticClass: "mt-1 mb-1 min-120-btn",
                  attrs: { variant: "primary" },
                  on: { click: _vm.updateStatusSubmit },
                },
                [
                  _c("span", { staticClass: "mr-25 align-middle" }, [
                    _vm._v(_vm._s(_vm.$t("ads.Save"))),
                  ]),
                ]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true



//# sourceURL=webpack:///./src/views/myads/ads.vue?./node_modules/cache-loader/dist/cjs.js?%7B%22cacheDirectory%22:%22node_modules/.cache/vue-loader%22,%22cacheIdentifier%22:%229dcd27b4-vue-loader-template%22%7D!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options

import * as bootstrapvue from 'bootstrap-vue';
import vue_select from 'vue-select';
import layouts_components_AdsFilter_vue from '@/layouts/components/AdsFilter.vue';
import assets_rashi_coin_ads_actions_svg from '@/assets/rashi-coin/ads-actions.svg';
import libs_api_api from '@/libs/api/api';
import moment from 'moment';
import layouts_components_KycNotComplete_vue from '@/layouts/components/KycNotComplete.vue';
import core_components_toastification_ToastificationContent_vue from '@core/components/toastification/ToastificationContent.vue';
import * as vuex from 'vuex';
import utils_constants from '@/utils/constants';
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











export default ({
  render,
  staticRenderFns,
  components: {
    BLink: bootstrapvue["BLink"],
    BRow: bootstrapvue["BRow"],
    BCol: bootstrapvue["BCol"],
    BCard: bootstrapvue["BCard"],
    BTable: bootstrapvue["BTable"],
    BButton: bootstrapvue["BButton"],
    BAvatar: bootstrapvue["BAvatar"],
    vSelect: vue_select,
    AdsFilter: layouts_components_AdsFilter_vue,
    AdsActions: assets_rashi_coin_ads_actions_svg,
    BPagination: bootstrapvue["BPagination"],
    KycNotComplete: layouts_components_KycNotComplete_vue,
    BFormGroup: bootstrapvue["BFormGroup"]
  },
  directives: {
    "b-tooltip": bootstrapvue["VBTooltip"]
  },
  data() {
    return {
      AddPayment: false,
      showPop: false,
      lang: this.$route.params.lang,
      fields: [{
        key: "id",
        label: this.$t("ad.AdsId"),
        tdClass: "n-wrap",
        thClass: "n-wrap"
      }, {
        key: "orderType",
        label: this.$t("ad.AdsType"),
        tdClass: "n-wrap",
        thClass: "n-wrap"
      }, {
        key: "coin",
        label: this.$t("ad.Coin"),
        tdClass: "n-wrap",
        thClass: "n-wrap"
      }, {
        key: "totalQuantity",
        label: this.$t("ad.TotalQuantity"),
        tdClass: "n-wrap",
        thClass: "n-wrap"
      }, {
        key: "rate",
        label: this.$t("ad.UnitPrice"),
        tdClass: "n-wrap",
        thClass: "n-wrap"
      }, {
        key: "createdTime",
        label: this.$t("Order.CreateTime"),
        tdClass: "n-wrap",
        thClass: "n-wrap"
      }, {
        key: "adStatus",
        label: this.$t("ad.Status"),
        tdClass: "n-wrap",
        thClass: "n-wrap"
      }, {
        key: "actions",
        label: this.$t("ad.Actions"),
        tdClass: "n-wrap text-center",
        thClass: "n-wrap text-center"
      }],
      items: [],
      type: null,
      coin: null,
      status: null,
      startTime: null,
      endTime: null,
      page: 1,
      size: 10,
      lang: this.$route.params.lang,
      isLoading: false,
      isPaginationVisible: false,
      totalRows: 0,
      updateStatus: false,
      adsStatus: "",
      adStatuses: ["PUBLISHED", "UNPUBLISHED", "CLOSED"],
      id: "",
      firstTime: true
    };
  },
  computed: {
    ...vuex.mapState("user", ["user", "refData"])
  },
  mounted() {
    if (this.$route && this.$route.query && this.$route.query.page) {
      this.page = this.$route.query.page;
    } else {
      this.getAllAds();
    }
    setTimeout(() => {
      this.firstTime = false;
    }, 5 * 1000);
  },
  watch: {
    size() {
      if (!this.size) {
        this.size = 10;
      }
      this.getAllAds();
    },
    page() {
      utils_constants["setPagination"].apply(this, [`${this.page}`]);
      this.getAllAds();
    },
    verificationStatus(newVal, oldVal) {
      if (!this.firstTime) {
        this.page = 1;
      }
      this.getAllAds();
    }
  },
  methods: {
    openUpdateStatus(flag, item) {
      this.updateStatus = flag;
      if (item && item.adStatus) {
        this.adsStatus = item.adStatus;
        this.id = item.id;
      } else {
        this.adsStatus = "";
        this.id = "";
      }
    },
    convertDate(date) {
      if (!date) return "";
      const str = String(date);
      if (moment(str, moment.ISO_8601, true).isValid()) {
        return moment(str).format("DD/MM/YYYY HH:mm");
      }
      const withZ = (str.endsWith("Z") || str.includes("+")) ? str : `${str}Z`;
      if (moment(withZ, moment.ISO_8601, true).isValid()) {
        return moment(withZ).format("DD/MM/YYYY HH:mm");
      }
      if (moment(date).isValid()) {
        return moment(date).format("DD/MM/YYYY HH:mm");
      }
      return date;
    },
    onModalHidden(props) {
      this.showPop = props;
    },
    createAd() {
      if (this.user && this.user.verificationStatus && this.user.verificationStatus === "APPROVED") {
        this.$router.push({
          name: "ad-post",
          params: {
            lang: this.lang || undefined
          }
        });
      } else {
        this.onModalHidden(true);
      }
    },
    showAddDetails(item) {
      this.$router.push({
        name: "ad-order",
        params: {
          id: item.id,
          lang: this.lang || undefined
        }
      });
    },
    callApi(props) {
      this.type = props.type;
      this.coin = props.coin;
      this.status = props.status;
      this.startTime = props.startTime;
      this.endTime = props.endTime;
      if (this.firstTime || this.page === 1) {
        this.getAllAds();
      }
      if (!this.firstTime) {
        this.page = 1;
      }
      // this.getAllAds();
    },
    showEditPayment() {
      this.EditPayment = true;
    },
    hideEditPayment() {
      this.EditPayment = false;
    },
    showAddPayment() {
      this.AddPayment = true;
    },
    hideAddPayment() {
      this.AddPayment = false;
    },
    addFilter(filter) {
      if (filter && this.verificationStatus != filter) {
        this.verificationStatus = filter;
      } else {
        this.verificationStatus = "";
      }
      if (!this.firstTime) {
        this.page = 1;
      }
      this.getAllAds();
    },
    async getAllAds() {
      try {
        this.isLoading = true;
        const res = await new libs_api_api().api({
          method: "GET",
          url: `p2p/ad/all`
        }, {
          type: this.type || undefined,
          coin: this.coin || undefined,
          status: this.status || undefined,
          startDate: this.startTime || undefined,
          endDate: this.endTime || undefined,
          page: this.page,
          size: this.size
        }, {
          isLoading: true
        });
        if (res && res.ads) {
          this.items = res.ads;
          this.totalRows = res.count;
          if (res.count && res.count > this.size) {
            this.isPaginationVisible = true;
          } else {
            this.isPaginationVisible = false;
          }
        } else if (res && res.error && res.error.message) {
          this.$toast({
            component: core_components_toastification_ToastificationContent_vue,
            props: {
              title: res.error.message,
              icon: "EditIcon",
              variant: "danger"
            }
          });
        }
      } catch (error) {
        this.$toast({
          component: core_components_toastification_ToastificationContent_vue,
          props: {
            title: error,
            icon: "EditIcon",
            variant: "danger"
          }
        });
      }
      this.isLoading = false;
    },
    async updateStatusSubmit() {
      try {
        const res = await new libs_api_api().api({
          method: "post",
          url: "p2p/ad/updateStatus"
        }, {
          id: this.id,
          status: this.adsStatus
        }, {});
        if (res && res.result && res.result.requestStatus == "SUCCESS") {
          this.updateStatus = false;
          this.$toast({
            component: core_components_toastification_ToastificationContent_vue,
            props: {
              title: this.$t("security.AdStatusUpdatedSuccessfully"),
              icon: "EditIcon",
              variant: "success"
            }
          });
          this.getAllAds();
        } else if (res && res.error && res.error.message) {
          this.$toast({
            component: core_components_toastification_ToastificationContent_vue,
            props: {
              title: res.error.message,
              icon: "EditIcon",
              variant: "danger"
            }
          });
        }
      } catch (error) {
        this.$toast({
          component: core_components_toastification_ToastificationContent_vue,
          props: {
            title: error,
            icon: "EditIcon",
            variant: "danger"
          }
        });
      }
    }
  }
});

//# sourceURL=webpack:///./src/views/myads/ads.vue?./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options
</script>

<style scoped>
.download-order-report {
  display: flex;
  justify-content: space-between;
  width: 100%;
}
.close-ads-text {
  font-size: 13px;
  color: #f42020;
}
[dir=ltr] .close-ads-text {
  text-align: left;
}
[dir=rtl] .close-ads-text {
  text-align: right;
}
.gray-btn {
  color: var(--gray);
}
</style>
